import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './services/user.service';
import { User } from './models/user.model';
import { Title } from '@angular/platform-browser';
import { ClickStreamService } from './services/click-stream.service';
import { StartupService } from './startup.service';
import { NotificationService } from './services/notification.service.';
import { NotificationModel } from './models/notification.model';
import {Location} from '@angular/common';
import { plaintext } from "../assets/plaintext";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Maxis';
  currentPage = 'Dashboard';
  subPage = '';

  isDashView: boolean = false;
  noReportHeader: boolean = false;
  user: User;
  isAdmin: boolean = false;
  backUrl = '';
  showBack = false;
  innerWidth: any;
  isMobile = false;
  showSideNav = true;

  errorInAuthentication = false;
  errorCode;
  isGame = false;
  completelyHideNavigation = false;

  notifications: NotificationModel[];
  plaintext = plaintext;

  constructor(private router: Router, private userService: UserService, private titleService: Title, private clickstream: ClickStreamService, private _location: Location,
    private startupService: StartupService, private notificationService : NotificationService) {
    router.events.subscribe(url => {
      let currUrl = this.router.url;
      if (currUrl == '/admin') {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }

      this.subPage = '';
      this.noReportHeader = false;
      if (window.location.href.indexOf('embed') != -1) {
        this.showBack = true;
        this.backUrl = '/reports';

        this.subPage = plaintext.reports.embedTitle[this.user.language];
        this.noReportHeader = true;
        this.showSideNav = false;
      } else if (!this.isMobile) {
        this.showSideNav = true;
      }

      // Handling the breadcrumbs
      if (currUrl.indexOf('/admin') > -1 || currUrl.indexOf('/reports/manage') > -1) {
        this.currentPage = plaintext.admin.title[this.user.language];
      } else if (currUrl == '/dashboard') {
        this.currentPage = plaintext.dashboard.title[this.user.language];
      } else if (currUrl == '/reports') { 
        this.currentPage = plaintext.reports.title[this.user.language];
      } else if (window.location.href.indexOf('admin/viewas') != -1) {
        this.isDashView = true;
      }
      // Handling sub pages and back urls
      if (currUrl == '/admin/push-chart') {
        this.subPage = 'Push Chart';
        this.backUrl = '/admin';
      } else if (currUrl.indexOf('/reports/manage') > -1) {
        this.subPage = plaintext.manageReports.title[this.user.language];
        if (currUrl.indexOf('manage/') > 1) {
          this.backUrl = '/reports/manage';
        } else {
          this.backUrl = '/reports';
        }
      } else if (window.location.href.indexOf('admin/viewas') != -1) {
        this.subPage = 'Dashboard View'
        this.backUrl = '/admin';
      } else if (window.location.href.indexOf('reports/viewas') != -1) {
        this.subPage = plaintext.reports.viewAsTitle[this.user.language]
        this.backUrl = '/reports';
      } else if (currUrl.indexOf('embed') > -1) {
        this.backUrl = '/reports';
      } else {
        this.backUrl = '';
        this.subPage = '';
      }
    })
    this.innerWidth = window.innerWidth;
    this.isMobile = this.innerWidth < 1000;
    this.showSideNav = this.innerWidth > 1000;
  }

  ngOnInit(): void {
    this.user = this.userService.user;
    this.notificationService.getNotifications().subscribe(notifications => {
      this.notifications = notifications;
    })
    if (this.user) {
      this.errorInAuthentication = false;
      if (this.user.businessFunction === 'unapproved') {
        if (this.user.isAdmin) this.backUrl = 'admin';
        let title = ''
        
        if (window.location.href.indexOf('suppliers') !== -1 || window.location.href.indexOf('autopartners') !== -1) title = ' Suppliers';
        else title = ' Third Parties';
        this.titleService.setTitle(`Maxis${title}`);
      }
    } else if (this.startupService.authenticationFailed) {
      this.errorCode = this.startupService.authErrorStatusCode;
      this.isGame = (window.location.href.indexOf('suppliers') === -1 && window.location.href.indexOf('autopartners') === -1);
      this.errorInAuthentication = true;
      console.log("in app component and is game",this.errorInAuthentication,this.isGame);
      if (window.location.href.indexOf("id_token") === -1 && window.location.href.indexOf("tonic_id") === -1 && this.errorCode) this.errorInAuthentication = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    
    this.isMobile = this.innerWidth < 1000 && !window.location.href.includes('embed');
    this.showSideNav = this.innerWidth > 1000 && !window.location.href.includes('embed');
  }

  toggleSideNav() {
    this.showSideNav = !this.showSideNav;
  }

  goBack() {
    if (window.location.href.includes('reports/viewas/embed') && document.referrer) {
      this._location.back();
    } else {
      this.router.navigate([this.backUrl]);
    }
    this.clickstream.send('go-back', 'click', 'Navigation', 'Back Button', '', true);
  }

}
